import * as React from 'react';

import { pageIndex, sections } from 'components/lexemes';
import { CdnImagePath } from 'lib/cdn-image-path';
import { downloadAction } from 'lib/seo/seo';

import { onAppleStoreClick, onClickDownloadNowCta, onGoogleStoreClick } from 'containers/events';

import PageSectionHeroSplash from 'components/page/sections/page-section-hero-splash';

export const LandingHeroBlockContainer: React.FC = () => {
  const props = {
    title: sections.introSection.lxPagePrivacyPolicyIntroSectionTitle(),
    backgroundImageSrcPortrait: `${CdnImagePath}/landing/assets/photos/landing-section-hero-1-landscape.jpg`,
    backgroundObjectPositionPortrait: '75% 34%',
    backgroundImageSrcLandscape: `${CdnImagePath}/landing/assets/photos/landing-section-hero-1-landscape.jpg`,
    backgroundObjectPositionLandscape: '77% 10%',
    subTitle: sections.introSection.lxPagePrivacyPolicyIntroSectionText(),
    actionText: pageIndex.lxPageIndexHeroBlockAction,
    actionUrl: downloadAction,
  };

  return (
    <PageSectionHeroSplash
      title={props.title}
      subTitle={props.subTitle}
      action={{
        text: props.actionText,
        href: props.actionUrl,
        onClick: onClickDownloadNowCta,
        onGoogleStoreClick,
        onAppleStoreClick,
      }}
      image={{
        srcPortrait: props.backgroundImageSrcPortrait,
        objectPositionPortrait: props.backgroundObjectPositionPortrait,
        srcLandscape: props.backgroundImageSrcLandscape,
        objectPositionLandscape: props.backgroundObjectPositionLandscape,
        hasFrontFilter: true,
        hasLoadPriority: true,
      }}
    />
  );
};
